/* ============================================================
   Karigur Bridal — Saved Looks
   Heart any look (no login, localStorage), review them in a drawer, and send
   them all to the atelier as ONE inquiry ("here is my whole wedding, dress it").
   - Hearts are injected onto product cards and wired onto explicit [data-kb-save]
     buttons (e.g. the PDP), so it works across the homepage, collections, and PDPs.
   - The drawer + launcher markup lives in snippets/kb-saved-looks.liquid.
   - On the inquiry page it injects the saved looks into the contact form as
     hidden fields + a visible summary, then clears them after a successful send.
   - Also on the inquiry page: ?look=<handle> (a product page's "Ask About This
     Piece") attaches that single piece to the form and names it above the form.
   - And ?location=karachi (the "Request a Karachi Appointment" buttons) names
     Noori House, Karachi above the form and carries it on the form.
   - Vanilla JS, no deps. Mobile-first.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'kb_saved_looks_v1';
  var MAX = 40;

  /* ---------------- store ---------------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('kb:saved:change', { detail: { count: list.length } }));
  }
  function has(handle) { return read().some(function (x) { return x.handle === handle; }); }
  function add(item) {
    var list = read();
    if (!item.handle || has(item.handle)) return list;
    list.unshift(item); write(list);
    try { if (window.kbTrack) window.kbTrack('saved_look_add', { kb_handle: item.handle }); } catch (e) {}
    return list;
  }
  function remove(handle) {
    write(read().filter(function (x) { return x.handle !== handle; }));
  }
  function toggle(item) { if (has(item.handle)) { remove(item.handle); } else { add(item); } }

  /* ---------------- helpers ---------------- */
  function handleFromHref(href) {
    if (!href) return '';
    var m = href.split('?')[0].split('#')[0].match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  }); }
  function HEART() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3l-1.3-1.2C6 14.9 3 12.2 3 8.8 3 6.2 5 4.2 7.6 4.2c1.5 0 2.9.7 3.8 1.8.9-1.1 2.3-1.8 3.8-1.8C20.6 4.2 22.6 6.2 22.6 8.8c0 3.4-3 6.1-7.7 10.4L12 20.3z"/></svg>';
  }
  function pulse(el) {
    el.classList.remove('kb-pulse'); void el.offsetWidth; el.classList.add('kb-pulse');
  }

  /* ---------------- save toggles ---------------- */
  function setBtnState(btn, saved) {
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', String(saved));
    var lbl = btn.querySelector('.kb-save-look__label');
    if (lbl) lbl.textContent = saved ? 'Saved' : (btn.getAttribute('data-kb-label') || 'Save this look');
    var a = saved ? 'Saved — tap to remove' : (btn.getAttribute('data-kb-label') || 'Save this look');
    btn.setAttribute('aria-label', a);
  }
  function itemFromBtn(btn) {
    return {
      handle: btn.getAttribute('data-kb-handle'),
      title: btn.getAttribute('data-kb-title') || btn.getAttribute('data-kb-handle'),
      url: btn.getAttribute('data-kb-url') || ('/products/' + btn.getAttribute('data-kb-handle')),
      image: btn.getAttribute('data-kb-image') || ''
    };
  }
  function onSaveClick(e) {
    var btn = e.currentTarget;
    e.preventDefault(); e.stopPropagation();
    var item = itemFromBtn(btn);
    if (!item.handle) return;
    toggle(item);
    pulse(btn);
  }
  function wireExplicit(scope) {
    (scope || document).querySelectorAll('[data-kb-save]').forEach(function (btn) {
      if (btn.getAttribute('data-kb-wired')) return;
      btn.setAttribute('data-kb-wired', '1');
      if (!btn.getAttribute('data-kb-label')) {
        var lbl = btn.querySelector('.kb-save-look__label');
        btn.setAttribute('data-kb-label', lbl ? txt(lbl) : 'Save this look');
      }
      setBtnState(btn, has(btn.getAttribute('data-kb-handle')));
      btn.addEventListener('click', onSaveClick);
    });
  }

  /* ---------------- inject hearts onto product cards ---------------- */
  function injectCardHearts(scope) {
    var root = scope || document;
    root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var handle = handleFromHref(a.getAttribute('href') || a.href || '');
      if (!handle) return;
      if (a.closest('[data-kb-saved], .kb-saved-summary')) return; // never heart the drawer / inquiry summary
      var card = a.closest('li, article, .product-card, .kb-look-card, .kb-shopcats__card') || a.closest('figure') || a.parentElement;
      if (!card || card.getAttribute('data-kb-save-done')) return;
      var img = card.querySelector('img');
      if (!img) return;
      // Skip tiny thumbnails (gallery thumbs, icons) — only the main card image gets a heart.
      if (img.width && img.width < 90 && img.naturalWidth && img.naturalWidth < 200) return;
      card.setAttribute('data-kb-save-done', '1');
      // Title: a product link with real text > a title element > image alt > prettified handle.
      var title = '';
      var plinks = card.querySelectorAll('a[href*="/products/"]');
      for (var k = 0; k < plinks.length; k++) { var t = txt(plinks[k]); if (t) { title = t; break; } }
      if (!title) title = txt(card.querySelector('.product-title, .kb-look-card__name, h2, h3, h4, [class*="title"]'));
      if (!title) title = (img.getAttribute('alt') || '').trim();
      if (!title) title = handle.replace(/[-_]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      // closest() starts at the element itself, so an <img> carrying one of these
      // classes matched itself. Appending the heart into a void element renders nothing.
      var media = img.parentElement
        ? (img.parentElement.closest('a, .kb-look-card__media, [class*="media"], [class*="gallery"], figure, .kb-shopcats__media') || img.parentElement)
        : null;
      if (media && getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kb-save-heart';
      btn.setAttribute('data-kb-save', '');
      btn.setAttribute('data-kb-handle', handle);
      btn.setAttribute('data-kb-title', title);
      btn.setAttribute('data-kb-url', '/products/' + handle);
      btn.setAttribute('data-kb-image', img.currentSrc || img.src || '');
      btn.setAttribute('data-kb-label', 'Save this look');
      btn.innerHTML = HEART();
      (media || card).appendChild(btn);
      wireExplicit(card);
    });
  }

  /* ---------------- drawer ---------------- */
  var W = {}; // cached nodes
  function q(sel) { return document.querySelector(sel); }
  function cacheNodes() {
    W.wrap = q('[data-kb-saved]');
    if (!W.wrap) return false;
    W.launcher = q('[data-kb-saved-open]');
    W.overlay = q('[data-kb-saved-overlay]');
    W.drawer = q('[data-kb-saved-drawer]');
    W.list = q('[data-kb-saved-list]');
    W.empty = q('[data-kb-saved-empty]');
    W.foot = q('[data-kb-saved-foot]');
    W.counts = document.querySelectorAll('[data-kb-saved-count]');
    return true;
  }
  function renderList() {
    if (!W.list) return;
    var list = read();
    W.list.innerHTML = list.map(function (x) {
      return '<div class="kb-saved-item" data-h="' + esc(x.handle) + '">' +
        '<a class="kb-saved-item__media" href="' + esc(x.url) + '">' +
          (x.image ? '<img src="' + esc(x.image) + '" alt="" loading="lazy">' : '<span class="kb-saved-item__ph"></span>') +
        '</a>' +
        '<div class="kb-saved-item__body">' +
          '<a class="kb-saved-item__name" href="' + esc(x.url) + '">' + esc(x.title) + '</a>' +
          '<button type="button" class="kb-saved-item__remove" data-kb-remove="' + esc(x.handle) + '">Remove</button>' +
        '</div></div>';
    }).join('');
    var n = list.length;
    if (W.empty) W.empty.hidden = n > 0;
    if (W.foot) W.foot.hidden = n === 0;
  }
  function syncCounts() {
    var n = read().length;
    if (W.counts) W.counts.forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
    if (W.launcher) W.launcher.hidden = n === 0;
    // reflect saved state on every visible save control
    document.querySelectorAll('[data-kb-save]').forEach(function (b) {
      setBtnState(b, has(b.getAttribute('data-kb-handle')));
    });
  }
  var _lastFocus = null;
  function focusables() {
    if (!W.drawer) return [];
    return Array.prototype.slice.call(W.drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  function trapTab(e) {
    if (e.key !== 'Tab' || !W.wrap || !W.wrap.classList.contains('is-open')) return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openDrawer() {
    if (!W.drawer) return;
    _lastFocus = document.activeElement;
    renderList();
    W.overlay.hidden = false; W.drawer.hidden = false;
    void W.drawer.offsetWidth; // force reflow so the slide-in transition runs (rAF can be throttled)
    W.wrap.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', trapTab, true);
    var c = W.drawer.querySelector('[data-kb-saved-close]'); if (c) c.focus();
  }
  function closeDrawer() {
    if (!W.wrap) return;
    var wasOpen = W.wrap.classList.contains('is-open');
    W.wrap.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', trapTab, true);
    setTimeout(function () { if (W.overlay) W.overlay.hidden = true; if (W.drawer) W.drawer.hidden = true; }, 280);
    // Restore focus to whatever opened the drawer (a11y: focus should not be lost).
    if (wasOpen && _lastFocus && _lastFocus.focus) { try { _lastFocus.focus(); } catch (e) {} }
  }
  function wireDrawer() {
    if (!cacheNodes()) return;
    W.wrap.hidden = false;
    /* Bind every Saved launcher (the header heart button + any floating pill). */
    document.querySelectorAll('[data-kb-saved-open]').forEach(function (l) { l.addEventListener('click', openDrawer); });
    if (W.overlay) W.overlay.addEventListener('click', closeDrawer);
    var c = q('[data-kb-saved-close]'); if (c) c.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && W.wrap && W.wrap.classList.contains('is-open')) closeDrawer(); });
    if (W.list) W.list.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-kb-remove]');
      if (rm) { e.preventDefault(); remove(rm.getAttribute('data-kb-remove')); renderList(); }
    });

    /* ---- share the board: link, or send it to the bridal team through the contact form ---- */
    function boardUrl() {
      var handles = read().map(function (x) { return x.handle; }).filter(Boolean);
      return location.origin + '/pages/saved-looks?looks=' + encodeURIComponent(handles.join(','));
    }
    function boardNames() { return read().map(function (x) { return x.title; }).join(' · '); }

    var shareBtn = q('[data-kb-saved-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = boardUrl();
        var lbl = shareBtn.querySelector('[data-kb-saved-share-label]');
        try { if (window.kbTrack) window.kbTrack('saved_looks_share', { kb_count: read().length }); } catch (e) {}
        if (navigator.share) {
          navigator.share({ title: 'My Karigur bridal looks', text: 'Here are the Karigur looks I love', url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            if (lbl) { var o = lbl.textContent; lbl.textContent = 'Link copied'; setTimeout(function () { lbl.textContent = o; }, 2000); }
          }).catch(function () { window.prompt('Copy your board link:', url); });
        } else { window.prompt('Copy your board link:', url); }
      });
    }

    var emailToggle = q('[data-kb-saved-email-toggle]');
    var emailForm = q('[data-kb-saved-email]');
    function fillEmailFields() {
      if (!emailForm) return;
      var n = emailForm.querySelector('[data-kb-saved-email-names]');
      var u = emailForm.querySelector('[data-kb-saved-email-url]');
      if (n) n.value = boardNames();
      if (u) u.value = boardUrl();
    }
    if (emailToggle && emailForm) {
      emailToggle.addEventListener('click', function () {
        var show = emailForm.hidden;
        emailForm.hidden = !show;
        emailToggle.setAttribute('aria-expanded', String(show));
        if (show) { fillEmailFields(); var inp = emailForm.querySelector('input[type="email"]'); if (inp) inp.focus(); }
      });
      emailForm.addEventListener('submit', function () {
        fillEmailFields();
        try { if (window.kbTrack) window.kbTrack('saved_looks_email', { kb_count: read().length }); } catch (e) {}
      });
      // If it was submitted (posted_successfully renders the done message), keep it visible.
      if (emailForm.querySelector('.kb-saved__email-done')) { emailForm.hidden = false; }
    }

    var enquireCta = q('[data-kb-saved-enquire]');
    if (enquireCta) { enquireCta.addEventListener('click', function () { try { if (window.kbTrack) window.kbTrack('saved_looks_inquiry', { kb_count: read().length }); } catch (e) {} }); }

    syncCounts();
  }

  /* ---------------- inquiry page integration ---------------- */
  var PENDING = KEY + '_pending_clear';
  var PENDING_MAX_AGE_MS = 15 * 60 * 1000;

  // The bridal inquiry form, and only that form. The first form[action*="/contact"] on most pages
  // is the footer newsletter, the booking checklist or a trade form; the board must never ride on
  // those, and a send from any of them must never wipe it.
  var INQUIRY_SELECTOR = 'form.kb-inquiry__form, form[data-kb-form-type="Bridal inquiry"]';
  function inquiryForm() { return document.querySelector(INQUIRY_SELECTOR); }

  function clearBoard() {
    try { localStorage.removeItem(KEY); localStorage.removeItem(PENDING); } catch (err) {}
    try { document.dispatchEvent(new CustomEvent('kb:saved:change', { detail: { count: 0 } })); } catch (err) {}
  }

  function injectIntoInquiry() {
    var list = read();
    if (!list.length) return;
    var form = inquiryForm();
    if (!form || form.getAttribute('data-kb-saved-injected')) return;
    // A form that has just been sent holds only its thank-you line: nothing to attach to.
    if (!form.querySelector('[name="contact[email]"]')) return;
    form.setAttribute('data-kb-saved-injected', '1');

    var names = list.map(function (x) { return x.title; }).join(' · ');
    var urls = list.map(function (x) { return (location.origin + x.url); }).join('\n');
    function hidden(name, val) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = name; i.value = val; return i;
    }
    form.appendChild(hidden('contact[Saved looks]', names));
    form.appendChild(hidden('contact[Saved look links]', urls));

    // Visible summary at the top of the form so she sees what she's sending.
    var summary = document.createElement('div');
    summary.className = 'kb-saved-summary';
    summary.innerHTML = '<p class="kb-saved-summary__title">Your saved looks (' + list.length + ') will be sent with this inquiry</p>' +
      '<div class="kb-saved-summary__row">' + list.map(function (x) {
        return '<a class="kb-saved-summary__chip" href="' + esc(x.url) + '">' +
          (x.image ? '<img src="' + esc(x.image) + '" alt="" loading="lazy">' : '') +
          '<span>' + esc(x.title) + '</span></a>';
      }).join('') + '</div>';
    form.insertBefore(summary, form.firstChild);

    // Native (page-reload) path: remember that THIS form was submitted. The mark is single use, expires
    // after a few minutes, and only counts if the next page shows this form's own thank-you line.
    form.addEventListener('submit', function () {
      try { localStorage.setItem(PENDING, String(Date.now())); } catch (err) {}
    });
  }
  // Seamless (AJAX) submit path fires kb:lead:sent instead of reloading. The board is cleared only when
  // the bridal inquiry form this script attached it to reports a send. The drawer's "share with our team"
  // form also carries contact[Saved looks]; sharing the board must NOT clear it (its success line says the
  // board stays in Saved Looks), and no other lead form (newsletter, checklist, trade) may clear it either.
  document.addEventListener('kb:lead:sent', function (e) {
    var f = e && e.detail && e.detail.form;
    if (!f || !f.getAttribute || !f.matches || !f.matches(INQUIRY_SELECTOR)) return;
    if (!f.getAttribute('data-kb-saved-injected') || f.hasAttribute('data-kb-saved-email')) return;
    if (!f.querySelector('[name="contact[Saved looks]"]')) return;
    clearBoard();
  });
  function maybeClearAfterSubmit() {
    var raw = null;
    try { raw = localStorage.getItem(PENDING); } catch (err) { return; }
    if (!raw) return;
    // Single use: whatever happened, the mark is spent by the next page load. A rejected post (422)
    // therefore cannot leave a mark behind for some later, unrelated ?contact_posted=true page.
    try { localStorage.removeItem(PENDING); } catch (err) {}
    var at = parseInt(raw, 10);
    if (!at || Date.now() - at > PENDING_MAX_AGE_MS) return;
    if (!/[?&]contact_posted=true(?:&|#|$)/.test(location.search)) return;
    // Shopify marks every contact form on a posted page as sent, so also require the inquiry form's own thank-you line.
    if (!document.querySelector('form.kb-inquiry__form [data-kb-lead-success], form[data-kb-form-type="Bridal inquiry"] [data-kb-lead-success]')) return;
    clearBoard();
  }

  /* "Ask About This Piece" on a product page links to the inquiry page as
     ?look=<handle>. Attach that one piece exactly as the form does when it sits on
     a product template (same field names, same visible line), so the team sees
     which piece was asked about. The handle is only used after /products/<handle>.js
     confirms a real product published to the Online Store. */
  function injectAskedLook() {
    var m = /[?&]look=([^&#]+)/.exec(location.search);
    if (!m) return;
    var handle = '';
    try { handle = decodeURIComponent(m[1]); } catch (e) { return; }
    if (!/^[a-z0-9][a-z0-9_-]*$/i.test(handle)) return;
    var form = document.querySelector('form.kb-inquiry__form');
    // No form, an already-sent form, or a product template that attached the look itself.
    if (!form || !form.querySelector('[name="contact[email]"]') || form.querySelector('[name="contact[Look of interest]"]')) return;
    if (!window.fetch) return;
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.title || !p.handle || form.querySelector('[name="contact[Look of interest]"]')) return;
        function hidden(name, val) {
          var i = document.createElement('input'); i.type = 'hidden'; i.name = name; i.value = val; return i;
        }
        form.appendChild(hidden('contact[Look of interest]', p.title));
        form.appendChild(hidden('contact[Look URL]', location.origin + '/products/' + p.handle));
        var note = document.createElement('p');
        note.className = 'kb-inquiry__look';
        note.setAttribute('role', 'note');
        note.appendChild(document.createTextNode('Your inquiry will include: '));
        var name = document.createElement('strong');
        name.textContent = p.title;
        note.appendChild(name);
        var wrap = form.closest('.kb-inquiry__form-wrap') || form;
        wrap.parentNode.insertBefore(note, wrap);
      })
      .catch(function () {});
  }

  /* "Request a Karachi Appointment" buttons link to the inquiry page as
     ?location=karachi (only that exact value is recognised). Name the studio above
     the form and carry it on the form so the team sees which studio was asked for.
     The form's own "Where would you like to meet?" select (contact[Consultation format])
     is switched to its Noori House option when it has one; otherwise a hidden
     contact[Location] field = "Karachi, Noori House" is added. The visible line
     follows the select if she changes it. All text here is constant (nothing from
     the URL is written into the page). */
  function injectAskedLocation() {
    var m = /[?&]location=([^&#]+)/.exec(location.search);
    if (!m) return;
    var wanted = '';
    try { wanted = decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return; }
    if (wanted !== 'karachi') return;
    var form = document.querySelector('form.kb-inquiry__form');
    // No form, an already-sent form, or one we have already handled.
    if (!form || !form.querySelector('[name="contact[email]"]') || form.getAttribute('data-kb-location-set')) return;
    form.setAttribute('data-kb-location-set', '1');

    var select = form.querySelector('select[name="contact[Consultation format]"]');
    var karachiIndex = -1;
    if (select) {
      for (var i = 0; i < select.options.length; i++) {
        if (/noori house/i.test(select.options[i].text)) { karachiIndex = i; break; }
      }
    }
    if (select && karachiIndex > -1) {
      select.selectedIndex = karachiIndex;
    } else {
      var hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'contact[Location]'; hidden.value = 'Karachi, Noori House';
      form.appendChild(hidden);
    }

    var note = document.createElement('p');
    note.className = 'kb-inquiry__look';
    note.setAttribute('role', 'note');
    note.appendChild(document.createTextNode('Your inquiry is for: '));
    var name = document.createElement('strong');
    name.textContent = 'Noori House, Karachi';
    note.appendChild(name);
    var wrap = form.closest('.kb-inquiry__form-wrap') || form;
    wrap.parentNode.insertBefore(note, wrap);
    if (select && karachiIndex > -1) {
      select.addEventListener('change', function () { note.hidden = select.selectedIndex !== karachiIndex; });
    }
  }

  /* ---------------- boot ---------------- */
  function scan(scope) { injectCardHearts(scope); wireExplicit(scope); }
  function init() {
    maybeClearAfterSubmit();
    wireDrawer();
    scan(document);
    injectIntoInquiry();
    injectAskedLook();
    injectAskedLocation();
    syncCounts();

    document.addEventListener('kb:saved:change', function () { renderList(); syncCounts(); });

    // Re-scan dynamically added content (infinite scroll, quick views, section reloads).
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            var n = muts[i].addedNodes[j];
            if (n.nodeType === 1) { scan(n); }
          }
        }
      });
      try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target || document); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
